import LineRegisterStart from "./LineRegisterStart";

export default function LineLoginPage() {
  return (
    <LineRegisterStart
      autoStart
      mode="login"
      entrySource="webApp"
      description="LINEでWizMateにサインインします"
      startButtonLabel="LINEでサインイン"
      loadingMessage="LINEを開いています..."
    />
  );
}
